























import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import Compra from '@/components/Compra.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    NavbarDark,
    Compra,
    Footer,
  },
})
export default class ComprarKit extends Vue {
  public data() {
    return {
      contents: [
        { title: 'Cucharillas de impresión', text: '2 cucharillas (superior e inferior). 3 sets de material para impresiones dentales, y un manual de instrucciones detalladas para que puedas tomarte las impresiones que usaremos para crear tus alineadores invisibles Toothly.'},
        { title: 'Evaluación fotográfica', text: 'Utiliza el retractor que incluimos en tu kit de impresiones Toothly para que nos envíes la foto de tu sonrisa inicial, lo cual nos servirá para desarrollar el plan de tratamiento ideal para tí.'},
        { title: 'Guía prepagada de envío', text: '¡No te preocupes! Incluimos una guía prepagada dentro de tu kit para que puedas regresar tus impresiones a nuestro laboratorio dental sin ningún costo extra.'},
        { title: 'Plan de Tratamiento', text: 'Una vez hayamos analizado tu sonrisa, te enviaremos un archivo digital que te enseñará lo increibles que se verán tus dientes después de tu tratamiento Toothly.'},

      ],
    };
  }
}
